export const API_BASE_URL = import.meta.env.VITE_BASE_URL;

export const LEGACY_DASHBOARD_URL = import.meta.env.VITE_LEGACY_DASHBOARD_URL;

export const URL_EXTENSION = 'api/v3';

// A check before using browser object or methods
export const IS_BROWSER =
  typeof window !== 'undefined' || typeof document !== 'undefined';

// Client storage vars
export const ACCESS_TOKEN = 'act';
export const THEME = 'theme';

export const ENV = import.meta.env.VITE_NODE_ENV;

// Voice identity UI is still being finalized. Only explicitly identified
// non-production builds expose it; missing configuration fails closed.
export const VOICE_PROFILES_UI_ENABLED =
  ENV === 'staging' ||
  ENV === 'development' ||
  (!ENV && import.meta.env.MODE === 'test');

// On-Prem deployment flag - when true, hides billing, reseller, and cloud-only features
export const IS_ON_PREM = import.meta.env.VITE_ON_PREM === 'true';

// Self-service registration. Disabled by default; opt back in with
// VITE_REGISTRATION_ENABLED=true. Mirrors the backend `registration.enabled`
// config — the signup API returns 403 when registration is off, so the UI
// hides the register link and routes to avoid dead-end forms.
export const REGISTRATION_ENABLED =
  import.meta.env.VITE_REGISTRATION_ENABLED === 'true';

export const MAX_FILE_SIZE: string =
  import.meta.env.VITE_MAX_FILE_SIZE || '42949672960';

export const KEYMAP_INPUT_KEY = 'keymap_user_setting';
export const DISABLE_NUMPAD_SHORTCUTS_KEY = 'disable_numpad_shortcuts';

export const API_ROOT = `${API_BASE_URL}/${URL_EXTENSION}`;
export const PUBLIC_BRANDING_URL = import.meta.env.VITE_BASE_URL;

// Always-on realtime WebSocket base (no scheme path). Env-driven so staging
// points at the Parakeet CPU lane (wss://realtime.scriptix.dev) and prod at
// wss://realtime.scriptix.io. Defaults to prod when the var is unset.
export const REALTIME_WS_URL =
  import.meta.env.VITE_REALTIME_WS_URL || 'wss://realtime.scriptix.io';

export const DOCUMENT_SOURCE_FILE_EXTENSIONS = [
  '.txt',
  'txt',
  '.docx',
  'docx',
  '.pdf',
  'pdf',
  '.doc',
  'doc',
  '.html',
  'html'
];
export const SUBTITLE_SOURCE_FILE_EXTENSIONS = [
  '.srt',
  'srt',
  '.vtt',
  'vtt',
  '.sbv',
  'sbv',
  '.ttml',
  'ttml',
  '.html',
  'html'
];

export const VIDEO_SOURCE_FILE_EXTENSIONS = [
  '.mp4',
  'mp4',
  '.mov',
  'mov',
  '.avi',
  'avi',
  '.mkv',
  'mkv',
  '.webm',
  'webm',
  '.m4v',
  'm4v',
  '.3gp',
  '3gp',
  '.flv',
  'flv',
  '.wmv',
  'wmv',
  '.ts',
  'ts'
];

export const AUDIO_SOURCE_FILE_EXTENSIONS = [
  '.mp3',
  'mp3',
  '.wav',
  'wav',
  '.m4a',
  'm4a',
  '.aac',
  'aac',
  '.ogg',
  'ogg',
  '.flac',
  'flac',
  '.wma',
  'wma',
  '.aiff',
  'aiff'
];

// Zapfeed (Bug Board). The key is board-scoped and rate limited server-side;
// it ships in the bundle like any other VITE_ var, so it must never be an
// admin-scoped key. Both vars must be present or the widget stays hidden.
export const ZAPFEED_URL: string = (
  import.meta.env.VITE_ZAPFEED_URL || ''
).replace(/\/+$/, '');
export const ZAPFEED_API_KEY: string =
  import.meta.env.VITE_ZAPFEED_API_KEY || '';
export const IS_ZAPFEED_ENABLED = !!ZAPFEED_URL && !!ZAPFEED_API_KEY;

export const DIALEKT_AI_API_KEY =
  ENV === 'production'
    ? import.meta.env.VITE_DIALEKT_AI_API_KEY_PROD
    : import.meta.env.VITE_DIALEKT_AI_API_KEY;
export const DIALEKT_AI_DB_ID =
  ENV === 'production'
    ? import.meta.env.VITE_DIALEKT_AI_DB_ID_PROD
    : import.meta.env.VITE_DIALEKT_AI_DB_ID;
